/**
 * 固资模块里成本中心的统一显示：「编码 名称」，如 "20SRE001 RE成本中心"。
 * 任一缺失时只显示另一个，都缺时返回空串。下拉选项、只读框、表格列都走这里，保证口径一致。
 */
export function costCenterText(code, name) {
    return [code, name].filter(o => o !== null && o !== undefined && String(o).trim() !== '').join(' ');
}
